(function() {
  function initSwipers() {
    const containers = document.querySelectorAll('.featured-collection-swiper');
    
    containers.forEach(container => {
      const sectionId = container.dataset.sectionId;
      
      new Swiper(container, {
        slidesPerView: 1.5,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: `[data-section-id="${sectionId}"] .swiper-next`,
          prevEl: `[data-section-id="${sectionId}"] .swiper-prev`,
        },
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipers);
  } else {
    initSwipers();
  }
})();


